import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";

interface CheckboxInputFieldProps extends FormFieldComponentProps {
  onCheckedChange?: (_checked: boolean) => void;
}

function CheckboxInputField({ form, name, label, disabled, onCheckedChange }: CheckboxInputFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex items-center space-x-3 w-full">
          <div className="flex items-center">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={(checked) => {
                  if (onCheckedChange) {
                    onCheckedChange(checked as unknown as boolean);
                  } else {
                    field.onChange(checked);
                  }
                }}
                disabled={disabled}
              />
            </FormControl>
            { label && <FormLabel className="font-light ml-2">{label}</FormLabel> }
          </div>
        </FormItem>
      )}
    />
  );
}

export default CheckboxInputField;
